<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <CategoryForm :baseCategory="category" :basecategoryName="name" :isUpdate="true" :categoryType="this.$route.params.type" :loading="loading" @submit-requested="submitRequested"></CategoryForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import CategoryForm from './CategoryForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                category: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { CategoryForm },
        computed:
        {
            ...mapState('categories', ['getCategoryByIdOutput']),
        },
        methods: {
            ...mapActions('categories', ['getCategoryById']),
            ...mapActions('categories', ['putCategory']),
            submitRequested(category) {
                this.putCategory(category);
            },
        },
        mounted: function () {
            if (!this.$route.query.id || !this.$route.params.type) {
                router.push({name: "CategoriesList"});

            }
            else {
                this.getCategoryById(this.$route.query.id);
            }
        },
        watch:
        {
            getCategoryByIdOutput: function (output) {
                if (!output && !output.data) {
                    router.push({name: "CategoriesList"});
                }
                else {
                    this.category = output.data;                    
                    this.loading = false;
                }
            }
        }
    }
</script>